<template>
  <div class="main">
    <div
      class="lists"
      v-infinite-scroll="loadmore"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10"
    >
      <div style="width: 100%; height: 50px; padding: 10px 20px">
        搜索：
        <a-input-search
          placeholder="请输入您要搜索的关键词"
          style="width: 400px; margin-right: 20px"
          v-model="param.keyword"
          @search="onSearch"
          @keyup.esc="reset"
        />
        <a-button type="primary" @click="reset()">重置</a-button>
      </div>
      <ul>
        <li>
          <div class="imgs" style="overflow-y: hidden">
            <!--http://media.cn3x.com.cn/api/AliyunVideo/videoUpload-->
            <a-upload-dragger
              accept="audio/*"
              name="file"
              :multiple="false"
              :customRequest="customRequest"
              :disabled="disabled"
            >
              <a-icon type="upload" ref="imgupload" /> 点击上传音频
            </a-upload-dragger>
            <!--<a-button type="dashed" style="width: 100%;height: 175px" icon="upload" @click="goUpload">上传</a-button>-->
          </div>
          <a-progress :percent="percent" v-if="disabled" />
        </li>
        <li v-for="(item, index) in lists" :key="index" class="img-lists">
          <div v-if="item.state && item.state != 0" @click="showDrawer(index)">
            <div class="imgs" style="background-color: #fafafa">
              <img src="../../../public/images/audio-default.jpg" alt="" />
            </div>
            <div class="title">{{ item.Title }}</div>
          </div>
          <div v-else>
            <section>
              <div class="sk-circle-bounce">
                <div class="sk-child sk-circle-1"></div>
                <div class="sk-child sk-circle-2"></div>
                <div class="sk-child sk-circle-3"></div>
                <div class="sk-child sk-circle-4"></div>
                <div class="sk-child sk-circle-5"></div>
                <div class="sk-child sk-circle-6"></div>
                <div class="sk-child sk-circle-7"></div>
                <div class="sk-child sk-circle-8"></div>
                <div class="sk-child sk-circle-9"></div>
                <div class="sk-child sk-circle-10"></div>
                <div class="sk-child sk-circle-11"></div>
                <div class="sk-child sk-circle-12"></div>
              </div>
            </section>
            <div style="height: 50px; line-height: 50px">转码中,请稍后...</div>
          </div>
        </li>
      </ul>
    </div>

    <a-drawer
      title="预览"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="visible"
      width="600"
    >
      <ali-player
        style="margin-bottom: 20px"
        @play="played"
        :source="aplayer.source"
        :autoplay="false"
        :vid="aplayer.vid"
        :playauth="aplayer.playauth"
        :cover="aplayer.cover"
        ref="player"
      ></ali-player>
      <a-row class="video-info">
        <a-col :span="6">标题</a-col>
        <a-col offset="1" :span="16">
          <div v-if="isEdit">
            <a-input v-model="aplayer.title" style="width: 60%" />
            <a-button type="primary" @click="saveEdit">保存</a-button>
            <a-button @click="cancelEdit">取消</a-button>
          </div>
          <div v-else>
            {{ aplayer.title }}
            <span class="edit" @click="editTitle()">编辑</span>
          </div>
        </a-col>
      </a-row>
      <!--<a-row class="video-info">-->
      <!--<a-col :span="6">视频ID</a-col>-->
      <!--<a-col offset="1" :span="16">{{ videoData.id }}</a-col>-->
      <!--</a-row>-->
      <a-row class="video-info">
        <a-col :span="6">资源ID</a-col>
        <a-col offset="1" :span="16" v-if="aplayer.vid">{{
          aplayer.vid.toUpperCase()
        }}</a-col>
      </a-row>
      <a-row class="video-info">
        <a-col :span="6">音频URL</a-col>
        <a-col offset="1" :span="16">
          <div
            style="
              border-radius: 3px;
              border: 1px solid #efefef;
              line-height: 24px;
              height: auto;
              word-break: break-all;
              padding: 0 5px;
            "
          >
            {{ this.aplayer.source }}
          </div>
          <!--<a-textarea v-model="videoData.FileURL" :autosize="{ minRows: 2, maxRows: 6 }"/>-->
        </a-col>
      </a-row>
      <a-row class="video-info">
        <a-col :span="6">下载音频</a-col>
        <a-col offset="1" :span="16">
          <a-icon
            type="download"
            style="font-size: 18px"
            @click="down(aplayer.downUrl)"
          />
        </a-col>
      </a-row>
      <a-row class="video-info">
        <a-col :span="6">时长</a-col>
        <a-col offset="1" :span="16" v-if="videoData.Duration"
          >{{ parseInt(videoData.Duration) }} 秒</a-col
        >
      </a-row>
      <a-row class="video-info">
        <a-col :span="6">创建时间</a-col>
        <a-col offset="1" :span="16" v-if="videoData.CreateTime">{{
          videoData.CreateTime
        }}</a-col>
      </a-row>
      <a-row
        class="video-info"
        style="
          margin-top: 20px;
          border-top: 1px solid #e8e8e8;
          padding-top: 20px;
        "
      >
        <a-col :span="12"
          ><a-button type="danger" @click="delVideo(videoData.id)"
            >删除</a-button
          ></a-col
        >
      </a-row>
    </a-drawer>
    <a-button
      type="primary"
      shape="circle"
      icon="reload"
      size="large"
      style="position: fixed; right: 50px; bottom: 50px"
      title="刷新"
      @click="refreshing"
    ></a-button>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
import VueAliplayer from '../../components/VueAliplayer';

var interval;

export default {
  name: 'Picture',
  components: { 'ali-player': VueAliplayer },
  directives: { infiniteScroll },
  data() {
    return {
      downkey: [],
      param: { page: 0, limit: 50, keyword: '' },
      lists: [],

      isEdit: false,
      visible: false,
      videoData: {},
      aplayer: {
        id: 0,
        title: '',
        source: '',
        vid: '',
        cover: '',
        downUrl: '',
        playauth:
          'eyJTZWN1cml0eVRva2VuIjoiQ0FJUzN3SjFxNkZ0NUIyeWZTaklxYXIzQm8zVm9lZGlqNWU1YW12OGswY3hPYmREaDdEQXRqejJJSHBLZVhkdUFlQVhzL28wbW1oWjcvWVlsck1xRnNFYkZCMlpNcHNwc2M4Sm9GUCtKcExGc3QySjZyOEpqc1ZsMDRWdmxsMnBzdlhKYXNEVkVma3VFNVhFTWlJNS8wMGU2TC8rY2lyWVhEN0JHSmFWaUpsaFE4MEtWdzJqRjFSdkQ4dFhJUTBRazYxOUszemRaOW1nTGlidWkzdnhDa1J2MkhCaWptOHR4cW1qL015UTV4MzFpMXYweStCM3dZSHRPY3FjYThCOU1ZMVdUc3Uxdm9oemFyR1Q2Q3BaK2psTStxQVU2cWxZNG1YcnM5cUhFa0ZOd0JpWFNaMjJsT2RpTndoa2ZLTTNOcmRacGZ6bjc1MUN0L2ZVaXA3OHhtUW1YNGdYY1Z5R0ZOLzducFNVUmJ2M2I0eGxMZXVrQVJtWGpJRFRiS3VTbWhnL2ZIY1dPRGxOZjljY01YSnFBWFF1TUdxQWRQTDVwZ2lhTTFyOUVQYmRnZmhtaTRBSjVsSHA3TWVNR1YrRGVMeVF5aDBFSWFVN2EwNDR4ckRoRzVnS3NNUWFnQUY2Qzl6eHF3VmdsSEFzTTJXdm11cmk1bFFRUHlYMXdndmJ4Mk91d3BRQmF0SEYrdW8wUnNURzllb2tVZmRMS0lpbkxsYlIvKys1MzlXN3BQM0k0T3h3ZjZIV2FjQTZQZVM2ZmpWQnZhd3BWSE5oNHdYR20rYk8xdUdtTXRraEhiMkExOTZUbEtYT0I4ZStEZUZ5Q1VpcVlrb21KaXdhTytGa0cxOW55SlVBUHc9PSIsIkF1dGhJbmZvIjoie1wiQ2FsbGVyXCI6XCJiY0o0ZFJHRFdRTjJnTEFvTk9nbVpwS0FMNEIxSk55YmNxaThOWkZCOERvPVxcclxcblwiLFwiRXhwaXJlVGltZVwiOlwiMjAxNy0xMC0yNVQwNjo1Mzo0N1pcIixcIk1lZGlhSWRcIjpcIjhkYjZlNWM3ZmY1ZjQyNTdiNDFlMjQ4N2VjNjFkNTkyXCIsXCJTaWduYXR1cmVcIjpcIlFHNTcwTXlrQWxzN1pxS1dTd2ppVStseTJrQT1cIn0iLCJWaWRlb01ldGEiOnsiU3RhdHVzIjoiTm9ybWFsIiwiVmlkZW9JZCI6IjhkYjZlNWM3ZmY1ZjQyNTdiNDFlMjQ4N2VjNjFkNTkyIiwiVGl0bGUiOiJXZUNoYXRfMjAxNzEwMTYxNjMzMTkiLCJDb3ZlclVSTCI6Imh0dHA6Ly92b2QubHVvYm9iYi5jb20vc25hcHNob3QvOGRiNmU1YzdmZjVmNDI1N2I0MWUyNDg3ZWM2MWQ1OTIwMDAwMS5qcGciLCJEdXJhdGlvbiI6NDIwLjB9LCJBY2Nlc3NLZXlJZCI6IlNUUy5IaUJNN2FMOEM4VVJoTU13R2Q1OG9odWtUIiwiUGxheURvbWFpbiI6InZvZC5sdW9ib2JiLmNvbSIsIkFjY2Vzc0tleVNlY3JldCI6IkRoZVdWNmJEMVBvN2pQbXJ1TFRDc25kQTFCUE5VTmpOb29iRnVEWnRqaDNlIiwiUmVnaW9uIjoiY24tc2hhbmdoYWkiLCJDdXN0b21lcklkIjoxNTY2OTk1NzgxNzM2OTg3fQ=='
      },
      player: null,
      percent: 0,
      disabled: false,
      busy: false,
      isLoadedAll: false //是否加载全部数据
    };
  },
  created() {
    var that = this;
    this.getLists();
  },
  mounted() { },
  methods: {
    onSearch() {
      this.param.page = 1;
      this.lists = [];
      this.getLists();
      // console.log('onsearch')
    },
    reset() {
      this.param.keyword = '';
      this.param.page = 1;
      this.lists = [];
      this.getLists();
    },
    loadmore() {
      if (!this.isLoadedAll) {
        this.param.page++;
        this.getLists();
      }
    },
    editTitle() {
      this.isEdit = true;
    },
    saveEdit() {
      let param = { id: this.aplayer.id, Title: this.aplayer.title };
      this.$http.post('/api/AliyunAudio/AudioEdit', param).then(res => {
        if (res.data.state == 200) {
          this.$message.success('操作成功');
          this.isEdit = false;
          this.visible = false;
          this.filename = [];
          this.param.page = 1;
          this.getLists();
        }
      });
    },
    cancelEdit() {
      this.isEdit = false;
    },
    played() {
      console.log('play callback');
    },
    showDrawer(index) {
      this.visible = true;
      this.videoData = this.lists[index];
      this.aplayer.id = this.videoData.id;
      this.aplayer.title = this.videoData.Title;
      this.aplayer.vid = this.videoData.VideoId;
      this.aplayer.downUrl = this.downkey[index].FileURL;
      this.aplayer.source = this.videoData.FileURL.replace(
        /fusion-media-wf.oss-cn-hangzhou.aliyuncs.com/,
        'cdn.ycrmt.cn'
      );
      const player = this.$refs.player;
      player && player.reloadPlayer();
    },
    onClose() {
      this.visible = false;
      const player = this.$refs.player;
      player.pause();
    },
    onChange(e) {
      this.placement = e.target.value;
    },
    async customRequest(filetxt) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Audioupload'
      );
      let that = this;
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let callback = data.callback;
      callback.customValue.Title = filetxt.file.name.substring(
        0,
        filetxt.file.name.lastIndexOf('.')
      ); //原文件名称
      let timestamp = new Date().getTime();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = filetxt.file.name.substring(
        filetxt.file.name.lastIndexOf('.') + 1
      ); //文件后辍
      this.disabled = true;
      let result = await client.multipartUpload(
        data.path +
        year +
        '/' +
        month +
        '/' +
        this.$md5(timestamp + filetxt.file.name) +
        '.' +
        fileExtension,
        filetxt.file,
        {
          progress: function (p, checkpoint) {
            // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。;
            that.percent = parseInt(p * 100);
          },
          meta: { year: 2020, people: 'test' }, //用户自定义的Header meta信息，Header前缀为x-oss-meta-。
          mime: 'text/plain', //设置Content-Type请求头。
          callback: callback
        }
      );
      if (result.data.errno === 0) {
        that.$message.success('文件上传成功');
        that.param.page = 1;
        that.getLists();
        interval = setInterval(function () {
          that.param.page = 1;
          that.getLists();
        }, 5000);
        that.disabled = false;
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    goUpload() {
      this.$refs.imgupload.click();
    },
    getLists() {
      if (!this.busy) {
        this.busy = true;
        this.$http
          .post('/api/AliyunAudio/AudioLists', this.param)
          .then(res => {
            this.downkey = this.deepCopy(res.data.data);
            if (this.param.page === 1) {
              this.lists = [];
            }
            if (
              parseInt(res.data.data.length) < parseInt(this.param.limit) ||
              res.data.state === 400
            ) {
              this.isLoadedAll = true;
            }
            for (let i in res.data.data) {
              if (
                res.data.data[i].Act &&
                typeof res.data.data[i].Act != 'undefined'
              ) {
                let actObj = JSON.parse(res.data.data[i].Act);
                if (typeof actObj[0].File.URL != 'undefiled') {
                  res.data.data[i].FileURL = actObj[0].File.URL;
                }
              }
              this.lists.push(res.data.data[i]);
            }
            if (this.lists.length) {
              this.videoData = this.lists[0];
              this.aplayer.id = this.videoData.id;
              this.aplayer.vid = this.videoData.VideoId;
              this.aplayer.title = this.videoData.Title;
              this.aplayer.source = this.videoData.FileURL;
            }

            if (this.videoData.state) {
              clearInterval(interval);
            }

            this.busy = false;
          })
          .catch(err => {
            this.busy = false;
          });
      }
    },
    refreshing() {
      this.param.page = 1;
      if (!this.busy) {
        this.busy = true;
        this.$http
          .post('/api/AliyunAudio/AudioLists', this.param)
          .then(res => {
            if (this.param.page === 1) {
              this.lists = [];
            }
            if (
              parseInt(res.data.data.length) < parseInt(this.param.limit) ||
              res.data.state === 400
            ) {
              this.isLoadedAll = true;
            }
            for (let i in res.data.data) {
              this.lists.push(res.data.data[i]);
            }
            this.videoData = this.lists[0];
            this.aplayer.id = this.videoData.id;
            this.aplayer.vid = this.videoData.VideoId;
            this.aplayer.title = this.videoData.Title;
            this.aplayer.source = this.videoData.FileURL;
            if (this.videoData.VideoId) {
              clearInterval(interval);
            }

            this.busy = false;
            this.$message.success('已刷新');
          })
          .catch(err => {
            this.busy = false;
          });
      }
    },
    delVideo(videoid) {
      var that = this;
      this.$confirm({
        title: '确定删除视频吗',
        content: '删除后将无法找回，确定吗？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          that.$http
            .post('api/AliyunAudio/AudioDel', { id: videoid })
            .then(res => {
              if (res.data.state == 200) {
                that.$message.success('已删除');
                that.isEdit = false;
                that.visible = false;
                that.filename = [];
                that.param.page = 1;
                that.getLists();
              }
            });
        },
        onCancel() { }
      });
    },
    down(url) {
      let that = this;
      console.log(url);
      this.$http({
        method: 'get',
        url,
        responseType: 'blob',
        params: {}
      }).then(res => {
        if (!res) {
          return;
        }
        // 将lob对象转换为域名结合式的url
        let blobUrl = window.URL.createObjectURL(res.data);
        let link = document.createElement('a');
        document.body.appendChild(link);
        link.style.display = 'none';
        link.href = blobUrl;
        // 设置a标签的下载属性，设置文件名及格式，后缀名最好让后端在数据格式中返回
        link.download = that.aplayer.title + '.mp3';
        // 自触发click事件
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    deepCopy(obj) {
      let clonedObj;
      let that = this;
      // 判断直接数据类型
      if (
        ['number', 'string', 'boolean', 'undefined', 'symbol'].includes(
          typeof obj
        ) ||
        obj === null
      ) {
        clonedObj = obj;
        return clonedObj;
      }
      const constructor = obj.constructor || Object;
      clonedObj = new constructor();
      Object.entries(obj).forEach(([key, value]) => {
        clonedObj[key] = that.deepCopy(value);
      });
      return clonedObj;
    }
  }
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  /*padding-top:10px*/
}

.lists {
  margin: 0 10px;
}
.lists ul li {
  float: left;
  width: 205px;
  height: 175px;
  text-align: center;
  cursor: pointer;
  padding: 0 10px;
  margin-bottom: 10px;
}
.lists ul li.img-lists:hover {
  background-color: #f2f6fc;
}
.lists .imgs {
  height: 145px;
  line-height: 145px;
}
.lists .title {
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
}
.lists ul li:hover .title {
  color: #409eff;
}
.lists ul li img {
  vertical-align: middle;
  max-width: 145px;
  max-height: 145px;
  border-radius: 5px;
}

.video-info {
  /*height: 40px;*/
  line-height: 40px;
}
.video-info > div:first-child {
  text-align: right;
}
.video-info button {
  margin-left: 5px;
}
.edit {
  color: #409eff;
  cursor: pointer;
}

section {
  flex: 1 1 25%;
  margin-top: 40px;
}
.sk-circle-bounce {
  width: 4em;
  height: 4em;
  position: relative;
  margin: auto;
  /*top: 30px;*/
}
.sk-circle-bounce .sk-child {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.sk-circle-bounce .sk-child:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #337ab7;
  border-radius: 100%;
  -webkit-animation: sk-circle-bounce-delay 1.2s infinite ease-in-out both;
  animation: sk-circle-bounce-delay 1.2s infinite ease-in-out both;
}
.sk-circle-bounce .sk-circle-2 {
  -webkit-transform: rotate(30deg);
  transform: rotate(30deg);
}
.sk-circle-bounce .sk-circle-3 {
  -webkit-transform: rotate(60deg);
  transform: rotate(60deg);
}
.sk-circle-bounce .sk-circle-4 {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.sk-circle-bounce .sk-circle-5 {
  -webkit-transform: rotate(120deg);
  transform: rotate(120deg);
}
.sk-circle-bounce .sk-circle-6 {
  -webkit-transform: rotate(150deg);
  transform: rotate(150deg);
}
.sk-circle-bounce .sk-circle-7 {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.sk-circle-bounce .sk-circle-8 {
  -webkit-transform: rotate(210deg);
  transform: rotate(210deg);
}
.sk-circle-bounce .sk-circle-9 {
  -webkit-transform: rotate(240deg);
  transform: rotate(240deg);
}
.sk-circle-bounce .sk-circle-10 {
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
.sk-circle-bounce .sk-circle-11 {
  -webkit-transform: rotate(300deg);
  transform: rotate(300deg);
}
.sk-circle-bounce .sk-circle-12 {
  -webkit-transform: rotate(330deg);
  transform: rotate(330deg);
}
.sk-circle-bounce .sk-circle-2:before {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.sk-circle-bounce .sk-circle-3:before {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
.sk-circle-bounce .sk-circle-4:before {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
.sk-circle-bounce .sk-circle-5:before {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
.sk-circle-bounce .sk-circle-6:before {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}
.sk-circle-bounce .sk-circle-7:before {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}
.sk-circle-bounce .sk-circle-8:before {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.sk-circle-bounce .sk-circle-9:before {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}
.sk-circle-bounce .sk-circle-10:before {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}
.sk-circle-bounce .sk-circle-11:before {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}
.sk-circle-bounce .sk-circle-12:before {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}

@-webkit-keyframes sk-circle-bounce-delay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes sk-circle-bounce-delay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.imgs i {
  margin: 20px;
  display: block;
  font-size: 50px;
  color: #40a9ff;
}
</style>
